<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column4">
					<div class="footer-logo">
						<h4>{{ defaults[locale].website.restaurantName }}</h4>

						<p class="small">
							Heerlijk genieten van een uitgebreide lunch of culinair diner met je partner, vrienden en
							vriendinnen, familie of zakelijk gezelschap
						</p>

						<social-media class="socials" :socials="socials" />
					</div>
				</div>

				<div class="columns column3">
					<h4>{{ $t('location') }}</h4>
					<p class="address small">
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>
					</p>
					<p class="address small">
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<font-awesome-icon class="icon" icon="fal fa-phone" size="1x" />
							{{ defaults[locale].website.phone }}
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`">
							<font-awesome-icon class="icon" icon="fal fa-envelope" size="1x" />
							{{ defaults[locale].website.email }}
						</a>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('quickLinks') }}</h4>

					<p class="small">
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
				<div class="columns column2">
					<h4>{{ $t('openingHours') }}</h4>

					<div v-parse-links class="small openinghours" v-html="defaults[locale].website.openingHours" />
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<p>
						<a
							class="author-link"
							href="https://www.deliciousdomain.com"
							target="_blank"
							rel="noopener noreferrer"
							title="Restaurant webdesign by Delicious Domain"
						>
							<span class="visually-hidden">Restaurant webdesign by Delicious Domain </span>
							<span
								role="img"
								aria-hidden="true"
								class="author-logo"
								v-html="DeliciousDomainAuthorLogo"
							/>
						</a>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
import DeliciousDomainAuthorLogo from '~/assets/images/author-logo-delicious-domain-currentcolor-except-icon.svg?raw';

const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footers {
	background: var(--footer-background-color);

	a,
	span,
	.small {
		color: var(--footer-color);
		text-decoration: none;
		font-size: 13px;

		.icon {
			margin-right: 3px;
		}
	}

	.openinghours {
		:deep(p:nth-child(odd)) {
			margin-bottom: 0;
		}
	}

	h3 {
		font-family: var(--heading-font-family);
	}

	h3,
	h4 {
		color: var(--header-color) !important;
		font-family: var(--heading-font-family);
		font-size: 24px;
		letter-spacing: 1px;
	}

	h4 {
		font-size: 20px;
	}
}

.main-footer {
	padding: 75px 0;
	font-size: 12px;
	width: 90%;

	p {
		font-size: 0.9em;
	}

	a,
	span {
		display: block;
	}

	a:hover {
		color: var(--footer-hover-color);
	}

	.footer-logo {
		margin: 0;
		max-width: 80%;
	}
}

.author-footer {
	font-size: 0.8em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	p {
		margin: 15px 0;
	}

	.border {
		background: var(--secondary-background-color);
		width: 100%;
		height: 1px;
	}

	.author-link {
		display: inline-flex;
		justify-content: center;
		width: 100%;
		padding: 0;
		transform: translateY(2px);
		margin-bottom: 20px;
	}

	.author-logo {
		display: inline-block;
		line-height: 0;
		max-width: 200px;

		&:hover {
			color: var(--cta-color-hover);
		}

		:deep(svg) {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.visually-hidden {
		position: absolute !important;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip-path: inset(50%);
		white-space: nowrap;
		border: 0;
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 0 auto 20px;
	}

	.main-footer {
		width: 100%;
	}
}

@media (max-width: 640px) {
	.main-footer {
		text-align: center !important;
		padding: 30px 5px;

		.footer-logo {
			display: flex;
			flex-flow: column;
			margin: 0 auto;
			align-items: center;

			.socials {
				margin-left: 30px;
			}
		}
	}
}
</style>
